import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipsComponent } from './chips.component';


@NgModule({
  imports: [CommonModule],
  exports: [ChipsComponent],
  declarations: [ChipsComponent]
})
export class ChipsModule {
}
